// Helper functions

// Format date to readable string
export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

// Format date and time
export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Format currency (GHS)
export const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) return 'GHS 0.00';
  return `GHS ${parseFloat(amount).toFixed(2)}`;
};

// Truncate text
export const truncateText = (text, maxLength = 100) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

// Get initials from name
export const getInitials = (name) => {
  if (!name) return '';
  const parts = name.split(' ');
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

// Calculate percentage
export const calculatePercentage = (value, total) => {
  if (!total || total === 0) return 0;
  return ((value / total) * 100).toFixed(1);
};

// Check if contest is active
export const isContestActive = (contest) => {
  if (!contest) return false;
  const now = new Date();
  const startDate = new Date(contest.startDate);
  const endDate = new Date(contest.endDate);
  return contest.status === 'ACTIVE' && now >= startDate && now <= endDate;
};

// Check if contest has ended
export const hasContestEnded = (contest) => {
  if (!contest) return false;
  const now = new Date();
  const endDate = new Date(contest.endDate);
  return now > endDate;
};

// Get contest status badge color
export const getContestStatusColor = (status) => {
  const colors = {
    DRAFT: 'bg-gray-200 text-gray-800',
    ACTIVE: 'bg-green-200 text-green-800',
    PAUSED: 'bg-yellow-200 text-yellow-800',
    ENDED: 'bg-red-200 text-red-800'
  };
  return colors[status] || 'bg-gray-200 text-gray-800';
};

// Get approval status badge color
export const getApprovalStatusColor = (status) => {
  const colors = {
    PENDING: 'bg-yellow-200 text-yellow-800',
    APPROVED: 'bg-green-200 text-green-800',
    REJECTED: 'bg-red-200 text-red-800'
  };
  return colors[status] || 'bg-gray-200 text-gray-800';
};

// Get vote status badge color
export const getVoteStatusColor = (status) => {
  const colors = {
    PENDING: 'bg-yellow-200 text-yellow-800',
    COMPLETED: 'bg-green-200 text-green-800',
    FAILED: 'bg-red-200 text-red-800'
  };
  return colors[status] || 'bg-gray-200 text-gray-800';
};

// Handle API errors
export const handleApiError = (error) => {
  if (error.response) {
    // Server responded with error
    return error.response.data.message || 'An error occurred';
  } else if (error.request) {
    // Request made but no response
    return 'Network error. Please check your connection.';
  } else {
    // Something else happened
    return error.message || 'An unexpected error occurred';
  }
};